"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.delay = void 0;
var delay = function (time) { return new Promise(function (resolve) { return setTimeout(resolve, time); }); };
exports.delay = delay;
//# sourceMappingURL=delay.js.map